import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CmsComponent } from './components/cms/cms.component';
import { CmsEditFormComponent } from './components/cms-edit-form/cms-edit-form.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { QuillModule } from 'ngx-quill'
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [CmsComponent, CmsEditFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatInputModule,
    MatTabsModule,
    MatTooltipModule,
    MatCardModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    QuillModule.forRoot()
  ],
  exports: [CmsComponent, CmsEditFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    CmsEditFormComponent
  ]
})
export class Q2AngularCmsModule {}
